// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import { InfoTooltip } from '../tooltips';

// Utils
import { FormattedMessage, formatMessageWithLocale } from '../../../utils/i18n';
import { DISCLAIMERS } from '../../../utils/disclaimers/constants';
import Locale from '@/types/locale';

type Props = {
  className?: string;
  disclaimerKey?: string;
  onClick?: () => void;
  id?: string;
  hideTooltip?: boolean;
  locale?: Locale;
};

const NotApplicableCell: React.FunctionComponent<Props> = ({ className, disclaimerKey, onClick, id, hideTooltip = false, locale }: Props) => {
  const i18nKey = disclaimerKey ? DISCLAIMERS[disclaimerKey].i18nKey : 'NotApplicable';

  return (
    <div className={classNames(className, 'cell not-applicable-cell')} onClick={onClick} id={id ? `cell-${id}` : undefined}>
      <span className="markup-container">
        <span className="label" aria-label={formatMessageWithLocale(`Disclaimers.${i18nKey}.Title`, locale)}>
          <FormattedMessage id="Common.NotApplicable" locale={locale} />

          {!hideTooltip && (
            <InfoTooltip
              title={formatMessageWithLocale(`Disclaimers.${i18nKey}.Title`, locale)}
              message={formatMessageWithLocale(`Disclaimers.${i18nKey}.Message`, locale)}
            />
          )}
        </span>
      </span>
    </div>
  );
};

export default NotApplicableCell;
